export default __webpack_public_path__ + "static/media/Self_Defence1.a12b565e.png";